import { Component, Input, inject } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { DetailPanelComponent } from '../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../core/panels/detail-panel/detail-item.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-sensitive-claim-access',
  template: `
    <div class="app-pb2 app-pt3">
      <div class="tw-pb-4">
        {{ info?.message }}
      </div>
      <div class="tw-flex tw-gap-8 tw-pb-4">
        <div class="tw-basis-1/2">
          <div class="tw-font-bold tw-pb-2">Examiner</div>
          <app-detail-panel [dataSource]="info?.contactInfo?.examiner">
            <app-detail-item label="Name" name="name" />
            <app-detail-item label="Phone" name="phone" format="p" />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/2">
          <div class="tw-font-bold tw-pb-2">Supervisor</div>
          <app-detail-panel [dataSource]="info?.contactInfo?.supervisor">
            <app-detail-item label="Name" name="name" />
            <app-detail-item label="Phone" name="phone" format="p" />
          </app-detail-panel>
        </div>
      </div>
      <app-action-row>
        <app-button
          icon="fa-check fa-light"
          (click)="onOkClick()"
          right1
          label="OK"
          labelCase="none"
        />
      </app-action-row>
    </div>
  `,
  styles: [``],
  imports: [
    ActionRowComponent,
    ButtonComponent,
    DetailPanelComponent,
    DetailItemComponent,
  ],
})
export class SensitiveClaimAccessComponent extends BaseComponent {
  private ref = inject(DynamicDialogRef);

  @Input()
  info: any;

  onOkClick(): void {
    this.ref.close();
  }
}
